import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetClientEvaluation, getMappedSupportPlannerBO, returnSupportPlannerBO } from './client-employee-contact.model';
@Injectable({
  providedIn: 'root'
})
export class ClientSupportRelationDateService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }


  public executesupportrealation(ANState: GetClientEvaluation): void {
    this.getsupportrelation(ANState).subscribe(x => super.next(x));
  }
  getsupportrelation(ANState: GetClientEvaluation): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/ClientSupportRelationship/GetClientSupportRelationList", ANState)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['listcli'],
            count: response['totalCount']
          }
      ))


  }


}